import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface AgeConfirmBoxProps {
  id: string
  age: number
  checked: boolean
  onChange: (checked: boolean) => void
  /** Shown under the box after a submit without it. */
  error?: string | null
  disabled?: boolean
  className?: string
}

/**
 * F-204: "I confirm I am N or older", unchecked, on every screen where a
 * person gets an account (sign-up, request to join, the invite's password).
 * The form does not go on without it; the API records the confirmation.
 */
export const AgeConfirmBox = ({ id, age, checked, onChange, error, disabled, className }: AgeConfirmBoxProps) => {
  const { t } = useTranslation('auth')
  return (
    <div className={cn('space-y-1', className)} data-testid="age-confirm">
      <label htmlFor={id} className="flex items-start gap-2 text-sm text-foreground-secondary">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? `${id}-error` : undefined}
          className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-border text-primary"
        />
        <span>{t('ageGate.confirm', { age })}</span>
      </label>
      {error && <p id={`${id}-error`} role="alert" className="text-sm text-danger-text">{error}</p>}
    </div>
  )
}
